// removed by extract-text-webpack-plugin
module.exports = {"label":"_1eCSYORVwEoTZO6yOzwPG3","input":"_2_YlR8xWoKF2zIX2cLeHzN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoanAmountRequested/style.scss
// module id = 2128
// module chunks = 1